import React from 'react'
import { Collapse } from 'antd'
const { Panel } = Collapse

interface PropsType {
  label: React.ReactNode,
  children: React.ReactNode
}

const ProjectDetailsCollapse: React.FC<PropsType> = ({ label, children }) => {
  return (
    <Collapse defaultActiveKey={['1']} ghost expandIconPosition='end'>
      <Panel header={label} key='1'>
        {children}
      </Panel>
    </Collapse>
  )
}

export default ProjectDetailsCollapse
